module.exports = __webpack_public_path__ + "fb493903265cad425ccdf8e04fc2de61.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.woff2
// module id = 32
// module chunks = 0